var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIdBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "id-badge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.056,
    height: 42.075,
    viewBox: "0 0 32.056 42.075",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "id-badge-solid",
    d: "M28.049,0H4.007A3.977,3.977,0,0,0,0,3.945V38.13a3.977,3.977,0,0,0,4.007,3.945H28.049a3.977,3.977,0,0,0,4.007-3.945V3.945A3.977,3.977,0,0,0,28.049,0ZM12.021,2.63h8.014a1.315,1.315,0,1,1,0,2.63H12.021a1.315,1.315,0,1,1,0-2.63Zm4.007,10.519a5.26,5.26,0,1,1-5.343,5.259A5.306,5.306,0,0,1,16.028,13.148Zm9.35,19.46a1.741,1.741,0,0,1-1.87,1.578H8.548a1.741,1.741,0,0,1-1.87-1.578V31.03c0-2.613,2.513-4.733,5.61-4.733h.417a8.724,8.724,0,0,0,6.645,0h.417c3.1,0,5.61,2.12,5.61,4.733Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdBadge);
export default __webpack_public_path__ + "static/media/id-badge.2d6a289e58da26c11142df74407a7b61.svg";
export { ForwardRef as ReactComponent };